import { createReducer } from '@reduxjs/toolkit';

import * as canvasActions from '../actions/canvas.action';

const initialState = {
  selected: {
    elements: [],
    isBackgroundSelected: false
  }
};

export default createReducer(initialState, builder => {
  builder
    .addCase(canvasActions.setSelectedElements, (state, { payload }) => {
      const isBackgroundSelected = payload.some(element => element.id?.includes?.('background'));

      state.selected.elements = payload;
      state.selected.isBackgroundSelected = isBackgroundSelected;
    });
});
